import React from "react";
import style from "./RiskAssessmentForm.module.scss";
import Tooltip from "../../../secondary/Tooltip/tooltip";
import ChipSelect from "../../../secondary/ChipSelect/ChipSelect";
import { Button, Form } from "../../../primary";
import InfoIcon from "../../../../static/images/info.svg";
import { Spinner } from "../../../secondary/Loader/Spinner";
import { CANCEL_BTN } from "../../../../constants";

const RiskAssessmentForm = ({
  mode,
  assessmentName,
  fields,
  formData,
  errors,
  onChipChange,
  onCancel,
  onSubmit,
  loading,
  riskLoading,
  detailLoading,
}) => {
  const heading = mode === "edit" ? `Edit | ${assessmentName || ""}` : "Create Risk Assessment";

  if (riskLoading || detailLoading) {
    return (
      <div className={style.panel}>
        <Spinner />
      </div>
    );
  }

  return (
    <div className={style.panel}>
      <div className={style.panelHeader}>
        <h2 className={style.panelTitle}>{heading}</h2>
      </div>

      <Form onSubmit={onSubmit}>
        <div className={style.grid}>
          {fields.map((field) => {
            const hasDesc = field.desc && field.desc !== "-";

            return (
              <div className={style.field} key={field.name}>
                <div className={style.label}>
                  {hasDesc && (
                    <Tooltip placement="right" content={field.desc}>
                      <img src={InfoIcon} alt="info" style={{ width: 18 }} />
                    </Tooltip>
                  )}
                  <span>{field.label}</span>
                  <span className={style.error}>&#42;</span>
                </div>

                <div className={style.chips_wrap}>
                  <ChipSelect name={field.name} value={formData[field.name]} onChange={onChipChange} options={field.options} />
                  {errors[field.name] && <span className={style.field_error}>{errors[field.name]}</span>}
                </div>
              </div>
            );
          })}
        </div>

        <div className={style.footer}>
          {mode === "edit" && (
            <Button type="button" classes={{ className: `btn ${style.btn_cancel}` }} onClick={onCancel}>
              {CANCEL_BTN}
            </Button>
          )}
          <Button classes={{ className: `btn ${style.btn_submit}` }} type="submit">
            {loading && <span className={style.custom_spinner}></span>}
            Submit
          </Button>
        </div>
      </Form>
    </div>
  );
};

export default RiskAssessmentForm;
